export default __webpack_public_path__ + "static/media/screen6.94bdc859.png";